export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/websites`;
}

export function Show(organizationID: number, siteID: number): string {
	return `/v1/organizations/${organizationID}/websites/${siteID}`;
}

export function Update(organizationID: number, siteID: number): string {
	return `/v1/organizations/${organizationID}/websites/${siteID}`;
}

